exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._29nyZ4KidIJk11t-3Gg_-c{font-weight:300;font-size:14px;font-weight:400;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._29nyZ4KidIJk11t-3Gg_-c{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"header": "_29nyZ4KidIJk11t-3Gg_-c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/config/mail/owa-storage-accounts-option/lib/components/HeaderContainer.scss
// module id = 4989
// module chunks = 2